import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowUpRight } from "lucide-react";
import SalaireSimulator from "@/components/SalaireSimulator";

export default function SimulateurSalaire() {
  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-[#DEE2E6]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src="/pag-logo.png" alt="PAG" className="h-10 w-10 object-contain" />
            <span className="font-display font-black text-xl">PAG</span>
          </Link>
          <Link to="/" className="text-sm font-semibold flex items-center gap-2 hover:text-[#002FA7]"><ArrowLeft className="h-4 w-4" /> Accueil</Link>
        </div>
      </header>

      <section className="border-b border-[#DEE2E6] bg-[#0A0A0A] text-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12 lg:py-16">
          <div className="text-xs uppercase tracking-[0.3em] text-[#FFD700] font-semibold mb-3">// Outil gratuit</div>
          <h1 className="font-display text-4xl lg:text-6xl font-black tracking-tighter leading-[0.95]">
            Simulateur<br />
            <span className="text-[#FFD700]">Brut → Net.</span>
          </h1>
          <p className="mt-4 text-base lg:text-lg text-white/70 max-w-2xl">
            Convertissez votre salaire brut en net en quelques secondes — cadre ou non-cadre, calculs des cotisations URSSAF, AGIRC-ARRCO et IR mensuel.
          </p>
        </div>
      </section>

      <main className="max-w-[1400px] mx-auto p-6 lg:p-10">
        <SalaireSimulator defaultBrut={2500} />
      </main>

      <section className="border-t border-[#DEE2E6] bg-[#F8F9FA]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12 grid lg:grid-cols-2 gap-8 items-center">
          <div>
            <div className="text-xs uppercase tracking-[0.3em] text-[#002FA7] font-semibold mb-3">// Pour aller plus loin</div>
            <h2 className="font-display text-3xl lg:text-4xl font-black tracking-tight leading-tight">
              Vos bulletins de paie<br />
              générés automatiquement.
            </h2>
            <p className="mt-4 text-sm text-[#495057] max-w-xl">
              PAG calcule les bruts/nets, génère les bulletins PDF, gère les heures sup et les primes pour toute votre équipe. Essayez sur un compte dédié.
            </p>
          </div>
          <div className="flex flex-wrap gap-3 lg:justify-end">
            <Link to="/inscription" data-testid="sim-cta-inscription" className="inline-flex items-center h-12 px-6 bg-[#002FA7] hover:bg-[#002175] text-white font-semibold text-sm">
              S'inscrire à PAG <ArrowUpRight className="ml-2 h-4 w-4" />
            </Link>
            <Link to="/" className="inline-flex items-center h-12 px-6 border border-[#0A0A0A] hover:bg-[#0A0A0A] hover:text-white font-semibold text-sm transition-colors">
              Retour à l'accueil
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
